export const LinkDownloadFileApk = `${window.location.origin}/app/scatter365.apk`;
